import {ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LOADING_REFERENCE } from 'src/app/share/constant/variable-constant';
import { DisableBrowserBFService } from 'src/app/share/services/disable-browser-bf-service/disable-browser-bf.service';
import { EventBusService } from 'src/app/share/services/event-bus-service/event-bus.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SpinnerComponent implements OnInit {
  @Input() hasLoadingImg: boolean = true;

  spinnerImg: Readonly<string> = `${environment.technicalHostUrl}/xrm/media/tech/img/loading_spinner.gif`;
  isLoading = LOADING_REFERENCE.isGlobalLoading.asObservable();
  isContentLoading = new BehaviorSubject<boolean>(false);

  constructor(private eventBusService: EventBusService, private disableBrowserBF: DisableBrowserBFService) { }

  ngOnInit(): void {
    this.ngOnContentLoading();
    this.ngOnGlobalLoading();
  }

  private ngOnContentLoading(): void {
    this.eventBusService.on('isContentLoading', value => {
      if (value.firstLoad) return;
      this.isContentLoading.next(value.isLoading);
      if (LOADING_REFERENCE.cacheValue === value.isLoading) return;
      LOADING_REFERENCE.cacheValue = value.isLoading;
      if (value.isLoading) return;
      this.disableBrowserBF.disableBrowserBackFn();
    });
  }

  private ngOnGlobalLoading() {
    this.eventBusService.on('isGlobalLoading', value => LOADING_REFERENCE.isGlobalLoading.next(value));
  }
}
